import BaseComponent from './BaseComponent';
import Rails from 'rails-ujs';

class InputSearch extends BaseComponent {
  constructor(componentName){
    super(componentName);

    this.lastSearch = '';
  }


  init(component) {
    this.addCustomEvents(component);
  }


  addCustomEvents(component) {
    this.watchInputValue(component);
  }


  watchInputValue(component) {
    const searchInput = component.element;
    const clearSearch  = document.getElementsByClassName('btn--clear-search')[0];
    let timeOut;

    searchInput.addEventListener('keyup', () => {
      const newSearch = searchInput.value;
      if (this.lastSearch !== newSearch && newSearch.length >= 2 || newSearch.length === 0) {

        clearTimeout(timeOut);
        timeOut = setTimeout(() => {
          this.lastSearch = newSearch;
          this.initSearch(searchInput, newSearch);
        }, 500);
      }


      // Hide clearSearch button when input is empty
      if(!!clearSearch) {
        if(newSearch.length === 0) {
          clearSearch.classList.add('is-hidden');
        } else {
          clearSearch.classList.remove('is-hidden');
        }
      }
    }, false);

    //disable Enter key in Search
    // searchInput.addEventListener('keydown', (e) => {
    //   if (e.keyCode == 13 ) {
    //     console.log('test!');
    //     return false;
    //   }
    // });

    // btn--clear-search
    component.element.nextElementSibling.addEventListener('click', () => {
      console.log('clear clicked  2');
      searchInput.value = '';

      const newSearch = searchInput.value;
      if (this.lastSearch !== newSearch && newSearch.length >= 2 || newSearch.length === 0) {
        clearTimeout(timeOut);
        timeOut = setTimeout(() => {
          this.lastSearch = newSearch;
          this.initSearch(searchInput, newSearch);
        }, 500);
      }

      if(!!clearSearch) {
        if(newSearch.length === 0) {
          clearSearch.classList.add('is-hidden');
        } else {
          clearSearch.classList.remove('is-hidden');
        }
      }
    });
  }



  initSearch(searchInput,value) {
    const params  = value.length > 0 ? `?q=${value}` : '';
    const form    = document.getElementsByClassName('search-wrapper')[0];
    const input   = form.getElementsByClassName('cmp-input-search')[0];
    const formURL = form.getAttribute('action');
    const url     = `${formURL}${params}`;


    // Actions
    //________
    this.searchInProgress(true);
    Rails.fire(form, 'submit');
    this.updateUrl(url);
    this.postAnalyticsData(form.getAttribute('data-lang'), input.value);
  }


  searchInProgress(active = false) {
    const resultsWrapper = document.getElementById('search');
    if(!!resultsWrapper) {
      active ? resultsWrapper.classList.add('searching') : resultsWrapper.classList.remove('searching');
    }
  }


  updateUrl(url) {
    const title = document.getElementsByTagName('title')[0].textContent;
    var state = { title: title };
    history.pushState(state, title, url);
  }


  updateResult(string, searchValue, loadPricesURL, ids) {
    if(searchValue === this.lastSearch) {
      const doc     = new DOMParser().parseFromString(string, 'text/html');
      const results = doc.body.firstChild;

      // results.classList.add('search');
      app.components.product.loadPrices(loadPricesURL, ids);

      const resultsWrapper = document.getElementById('search');
      if(!!resultsWrapper) {
        resultsWrapper.innerHTML = '';
        resultsWrapper.appendChild(results);
        // debugger;
        setTimeout(() => {
          this.searchInProgress(false);
        }, 200);
      }
    }
  }


  blur(element) {
    element.blur();
  }



  postAnalyticsData(lang, term) {
    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
      'event': 'Search',
      'lang': lang,
      'term': term
    });
  }
}
export default InputSearch;
